import type { RouterState } from './types';

const initialState: RouterState = {
  history: [],
};

export default initialState;
